var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MailboxInlinePicker',{attrs:{"account":_vm.account,"value":_vm.mailbox},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }